(function ($) {
  $(document).ready(function () {
    function showOverlay() {
      $(".site-overlay").addClass("show_overlay");
    }

    function hideOverlay() {
      $(".site-overlay").removeClass("show_overlay");
    }

    function headerSearchFormInput() {
      const siteHeader = $("main-header#site-header");
      const rootContainer = $("search-form.header_search_full_width");
      const resultContainer = rootContainer.find(".top");

      rootContainer.find("#search-form-sidebar").on("input", function () {
        const currentValue = $(this).val();
        console.log("currentValue", currentValue, resultContainer);

        if (!!currentValue) {
          resultContainer.addClass("show");
          siteHeader.addClass("above_overlay");
          showOverlay();
        } else {
          resultContainer.removeClass("show");
          siteHeader.removeClass("above_overlay");
          hideOverlay();
        }
      });

      $(document).mousedown(function (e) {
        const searchHeaderContainer = $("search-form.header_search_full_width");

        if (
          searchHeaderContainer.length &&
          !searchHeaderContainer.is(e.target) &&
          searchHeaderContainer.has(e.target).length === 0
        ) {
          resultContainer.removeClass("show");
          siteHeader.removeClass("above_overlay");
          hideOverlay();
        }
      });
    }

    headerSearchFormInput();
    
    function openHeaderCatalogMenu() {
      $('.site-nav-container .js-mega-menu-item.catalog_menu_item a.menu-link').click(function() {
        $(this).closest('.catalog_menu_item').toggleClass('focus')
      })

      $(document).mousedown(function (e) {
        const catalogSubmenu = $('.site-nav-container .js-mega-menu-item.catalog_menu_item');

        if (
          catalogSubmenu.length &&
          !catalogSubmenu.is(e.target) &&
          catalogSubmenu.has(e.target).length === 0
        ) {
          catalogSubmenu.removeClass('focus')
        }
      });
    }

    openHeaderCatalogMenu();

     function calculateProductItemQuickButtonContainer() {
      $('.product-item[data-js-product-item]').each(function() {
        const productItemRootContainer = $(this);
        const quickBuyContainer = productItemRootContainer.find('.product-item__quick-buy')

        if (quickBuyContainer.length) {
          productItemRootContainer.css('--additional-height', `${quickBuyContainer.innerHeight() }px`)
        }
      })
    }

    $(window).on('resize', calculateProductItemQuickButtonContainer)

    calculateProductItemQuickButtonContainer();
  });
})(jQuery);
